import navBarHomepage from '../modules/navbar-homepage';
import mobileBottomSocialBar from '../modules/mobile-bottom-social-bar';
import postShareButtons from '../modules/post-share-buttons';
import micSectors from '../modules/mic-sectors';
import micSidebar from '../modules/mic-sidebar';

let micController = () => {
    require('../modules/optout')();
    require('../modules/slideshow/create_mic_slideshow')();
    navBarHomepage.on();
    mobileBottomSocialBar.on();
    postShareButtons.on();
    micSectors();
    micSidebar();
};

export default micController;
